export const LOAD_UPCOMING_CATALOGS_FAIL = 'la/domain/upcomingCatalogs/LOAD_FAIL';
export const LOAD_UPCOMING_CATALOGS_REQUEST = 'la/domain/upcomingCatalogs/LOAD_REQUEST';
export const LOAD_UPCOMING_CATALOGS_SUCCESS = 'la/domain/upcomingCatalogs/LOAD_SUCCESS';
